import styled from "styled-components";
import { colorMixin, typographyMixin } from "../../../helpers";

export const StyledInput = styled.input`
    outline: none;
    border: none;
    padding: 0;
    margin: 0;
    width: 100%;
    max-width: 100%;
    position: absolute;
    ${typographyMixin("label-small-regular")}
    color: ${colorMixin("text-primary-1200")};
    cursor: pointer;

    :focus {
        cursor: text;
    }

    &::placeholder {
        color: ${colorMixin("text-primary-700")};
    }
`;
